/**
 * @file menu.tsx
 * @description Компонент для работы и отоюражения бокового меню приложения.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react-router-dom, react-redux, @store/slices/menu-slice, @components/ui/indicators/loader]
 * @related-files [@components/left-menu/item, @store/slices/menu-slice, @store/index, ./item]
 */

import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    getMainMenuItems,
    getActiveMainMenuGroup,
    getActiveMainMenuItem,
    fetchMenuItems,
    setActiveItem,
    setActiveGroup
} from '@store/slices/menu-slice';
import { Loader } from '@components/ui/indicators/loader';
import { Item } from './item';
import { useEffect } from 'react';
import { AppDispatch } from '@store/index';
import { TMenuItem } from '@src/types';

export const Menu = () => {
    const location = useLocation();
    const items: TMenuItem[] = useSelector(getMainMenuItems);
    const activeGroup: TMenuItem | null = useSelector(getActiveMainMenuGroup);
    const activeItem: TMenuItem | null = useSelector(getActiveMainMenuItem);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (!items.length) {
            dispatch(fetchMenuItems());
        }
    }, []);

    const onChangeActiveItem = (newActiveItem: TMenuItem | null) => {
        if (newActiveItem && location.pathname) {
            if (`/${newActiveItem.$route}` !== location.pathname) {
                dispatch(setActiveItem(newActiveItem));
            }
        }
    };

    useEffect(() => {
        if (location.pathname !== '/' && !activeItem && items.length) {
            let newActiveItem = null;
            const newActiveGroup = items.find((group) => {
                const currentItem = group.$subMenu?.find((item) => `/${item.$route}` === location.pathname);
                if (currentItem) {
                    newActiveItem = currentItem;
                    return group;
                }
            });

            if (newActiveGroup && newActiveItem) {
                dispatch(setActiveGroup(newActiveGroup));
                dispatch(setActiveItem(newActiveItem));
            }
        }
    }, [location.pathname, activeItem, items]);

    return (
        <div className="LeftMenu h-full">
            {items?.length ? (
                items.map((item, key) => (
                    <Item
                        key={key}
                        item={item}
                        activeItem={activeItem}
                        onChangeActiveItem={onChangeActiveItem}
                        activeGroup={activeGroup}
                        disabled={item.$isDisabled}
                    />
                ))
            ) : (
                <Loader size="m" className="flex items-center my-[0.5079vmin]" />
            )}
        </div>
    );
};
